import { Box, Grid, Chip, Tooltip } from "@mui/material";
import React, { useEffect, useState, useMemo } from "react";
import apis from "../../services";
import useNavigate from "hooks/Navigate";
import { DataGrid } from "@mui/x-data-grid";
import Toolbar from "components/@material-extend/CustomToolbar";
import { toast } from "react-toastify";
import AdminNewSidebar from "components/admin/AdminNewSidebar";
import { Header } from "components";
import Container from "@mui/material/Container";
import { useTranslation } from "react-i18next";
import DeleteModal from "components/modals/DeleteModal";
import { Button } from "react-bootstrap";
import { MdEdit, MdDelete, MdVisibility } from "react-icons/md";
import { Check } from "@mui/icons-material";
import { BsX } from "react-icons/bs";
import { FiX } from "react-icons/fi";

export const Beneficiary = () => {
  const [users, setUsers] = useState([]);
  const [status, setStatus] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showDiv, setShowDiv] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [tab, setTab] = useState("all");
  const [show, setShow] = useState(false);
  const [userId, setUserId] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loadingUserTable, setLoadingUserTable] = useState(false);

  const handleManageClaim = async (id, body) => {
    try {
      const res = await apis.manageClaimRequest(id, body);

      console.log("Response:", res);

      if (res?.data?.message) {
        toast.success(res.data.message);
      }
    } catch (error) {
      console.log("API Error:", error);
      const msg = error?.response?.data?.message || "Something went wrong";
      toast.error(msg); // or toast
    }
  };

  // Define columns for DataGrid
  const columns = useMemo(
    () => [
      {
        field: "name",
        headerName: "Name",
        width: 180,
        renderCell: (params) => (
          <div style={{ fontWeight: 500 }}>{params.value}</div>
        ),
      },
      {
        field: "nickName",
        headerName: "Nickname",
        width: 150,
      },
      {
        field: "email",
        headerName: "Email",
        width: 220,
      },
      {
        field: "phone",
        headerName: "Phone",
        width: 150,
      },
      {
        field: "category",
        headerName: "Category",
        width: 120,
        renderCell: (params) => (
          <Chip
            label={params.value}
            size="small"
            color="primary"
            variant="outlined"
          />
        ),
      },
      {
        field: "isVerified",
        headerName: "Verified",
        width: 100,
        renderCell: (params) => (
          <Chip
            label={params.value ? "Yes" : "No"}
            size="small"
            color={params.value ? "success" : "default"}
          />
        ),
      },
      {
        field: "isKYCCompleted",
        headerName: "KYC Status",
        width: 130,
        renderCell: (params) => {
          const colorMap = {
            pending: "warning",
            completed: "success",
            rejected: "error",
          };
          return (
            <Chip
              label={params.value}
              size="small"
              color={colorMap[params.value] || "default"}
            />
          );
        },
      },
      {
        field: "totalInvestmentAmount",
        headerName: "Investment",
        width: 130,
        renderCell: (params) => (
          <span>${params.value?.toLocaleString() || 0}</span>
        ),
      },
      {
        field: "totalShares",
        headerName: "Shares",
        width: 100,
      },
      {
        field: "beneficiaries",
        headerName: "Beneficiaries",
        width: 120,
        renderCell: (params) => (
          <Chip label={params.value?.length || 0} size="small" color="info" />
        ),
      },
      {
        field: "reason",
        headerName: "Reason",
        width: 120,
        renderCell: (params) => (
          <Chip
            label={params.row.beneficiaryclaimedBy.reason || '-'}
            size="small"
            color="info"
          />
        ),
      },
      {
        field: "claimedBy",
        headerName: "Claim Request By",
        width: 200,
        renderCell: (params) => {
          const claimedByData = params.row.beneficiaryclaimedBy?.claimedBy;

          if (!claimedByData) return <span>-</span>;

          return (
            <Tooltip
              title={
                <div>
                  <div>
                    <strong>Name:</strong> {claimedByData.name}
                  </div>
                  <div>
                    <strong>Email:</strong> {claimedByData.email}
                  </div>
                  <div>
                    <strong>Phone:</strong> {claimedByData.phone}
                  </div>
                  <div>
                    <strong>Nickname:</strong> {claimedByData.nickName}
                  </div>
                </div>
              }
              arrow
            >
              <div
                style={{
                  cursor: "pointer",
                  color: "#1976d2",
                  textDecoration: "underline",
                }}
              >
                {claimedByData.name}
              </div>
            </Tooltip>
          );
        },
      },
      {
        field: "claimStatus",
        headerName: "Claim Status",
        width: 150,
        renderCell: (params) => {
          const status = params.row.beneficiaryclaimedBy?.status;
          if (!status) return "-";

          const colorMap = {
            "Request-Pending": "warning",
            Approved: "success",
            Rejected: "error",
          };

          return (
            <Chip
              label={status}
              size="small"
              color={colorMap[status] || "default"}
            />
          );
        },
      },
      {
        field: "files",
        headerName: "Files",
        width: 180,
        renderCell: (params) => {
          const files = params.row.beneficiaryclaimedBy?.files;

          if (!files || files.length === 0) return "-";

          return (
            <Chip
              label="Download All"
              color="success"
              size="small"
              onClick={() =>
                window.open(
                  `${process.env.REACT_APP_SERVER_URL}/api/users/download-claim-files/${params.row._id}`,
                  "_blank"
                )
              }
            />
          );
        },
      },

      {
        field: "wallet",
        headerName: "Wallet",
        width: 200,
        renderCell: (params) => (
          <Button
            variant="link"
            size="sm"
            // onClick={() => copyToClipboard(params.value)}
            style={{ padding: 0, fontSize: "12px" }}
          >
            {params.value ? `${params.value.substring(0, 20)}...` : "-"}
          </Button>
        ),
      },
      {
        field: "createdAt",
        headerName: "Created At",
        width: 180,
        renderCell: (params) =>
          new Date(params.value).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          }),
      },
      {
        field: "actions",
        headerName: "Actions",
        width: 150,
        sortable: false,
        renderCell: (params) => (
          <div style={{ display: "flex", gap: "8px" }}>
            {params.row.beneficiaryclaimedBy?.status !== "Request-Accepted" ? (
              <>
                <Button
                  title="Approve"
                  onClick={() =>
                    handleManageClaim(params.row.beneficiaryclaimedBy?._id, {
                      status: "Approve",
                    })
                  }
                >
                  <Check />
                </Button>
                <Button
                  size="xl"
                  //   onClick={() => openModal(params.row.id)}
                  title="Disapprove"
                  onClick={() =>
                    handleManageClaim(params.row.beneficiaryclaimedBy?._id, {
                      status: "UnApprove",
                    })
                  }
                >
                  <FiX />
                </Button>
              </>
            ) : (
              "-"
            )}
          </div>
        ),
      },
    ],
    [navigate]
  );

  // Transform API data to DataGrid format
  const rows = useMemo(() => {
    return (
      users?.map((user) => ({
        id: user._id,
        ...user,
      })) || []
    );
  }, [users]);

  /*Methods*/
  const fetchAllUsers = async () => {
    setLoadingUserTable(true);
    try {
      const res = await apis.getClaimRequests();
      setUsers(res.data.data);
    } catch (error) {
      toast.error("Failed to fetch users");
    } finally {
      setLoadingUserTable(false);
    }
  };

  useEffect(() => {
    fetchAllUsers();
  }, []);

  return (
    <>
      <Box className="dashboard-main">
        <AdminNewSidebar />
        <div className="dashboard-section-main">
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              height: "100vh",
              overflow: "auto",
            }}
            className="custom-scroll"
          >
            <Header />

            {loadingUserTable ? (
              <div className="loader-container">
                <div className="loader" />
              </div>
            ) : (
              <Container sx={{ mt: 4, mb: 4 }} className="mainContainerComp">
                <Grid
                  item
                  container
                  justifyContent="flex-end"
                  className="mt-4"
                  sx={{ height: "600px" }}
                >
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "even"
                        : "odd"
                    }
                    pagination
                    pageSize={10}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    disableSelectionOnClick
                    loading={loadingUserTable}
                    sx={{
                      "& .MuiDataGrid-cell:focus": {
                        outline: "none",
                      },
                      "& .MuiDataGrid-row:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.04)",
                      },
                    }}
                  />
                </Grid>
              </Container>
            )}
          </Box>
        </div>
      </Box>
    </>
  );
};

export default Beneficiary;